document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  lenis.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {
		lenis.raf(time * 1000); // Convert time from seconds to milliseconds
	  });
	 gsap.ticker.lagSmoothing(0);
    const lmglw = gsap.timeline({})

  lmglw

  .fromTo('.luma', {
    opacity: 0,
    yPercent: -35,
  }, {
    opacity: 1,
    duration: 1,
    yPercent: 0,
  },"1")
  .fromTo('.glow', {
    opacity: 0,
    duration: 1,
    yPercent: 35,
  }, {
    opacity: 1,
    yPercent: 0,
  }, "<")
  .fromTo('.lmgh-1', {
    opacity: 0,
    yPercent: 10
  }, {
    opacity: 1,
    duration: 0.75,
    yPercent: 0,
    ease: 'power4.inOut',
    stagger: {
      each: 0.15,
      from: 'end'
    }
  }, ">-=0.25")

});